import BackgroundInfoButton from "./BackgroundInfoButton";
export default BackgroundInfoButton;
